module.exports = __webpack_public_path__ + "img/userB18.a556f412.jpg";